import React from 'react';
import { Link } from "react-router-dom";
import './Footer.css';

export default function Footer() {
  return (
    // <div className='footer p-5'>
    //   <div className='row mt-4'>
    //     <div className="col-md-3 mb-4 footer-left">
    //       <img src="./assets/images/logoLong.png" alt="Logo" className="footer-logo" />
    //       <p className="footer-copy">&copy; All Right Reserved</p>

    //       <p className="footer-links">
    //         <Link to="/privacy-policy">Privacy Policy</Link>
    //         <Link to="/terms-and-conditions">Terms & Conditions</Link>
    //       </p>

    //       <div className="social-icons">
    //         <a href="https://www.linkedin.com/company/ambrumsolutions/" target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin"></i></a>
    //         <a href="https://www.facebook.com/ambrumSL" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook"></i></a>
    //         <a href="https://www.instagram.com/ambrum.s/" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
    //       </div>

    //       <div className="footer-divider" />
    //     </div>

    //     <div className="col-md-2 mb-4" >
    //       <h5>Company</h5>
    //       <ul className="list-unstyled">
    //         <li> <Link to="/about">About</Link></li>
    //         <li> <Link to="/services">Services</Link></li>
    //         <li> <Link to="/careers">Careers</Link></li>
    //       </ul>
    //     </div>

    //     <div className="col-md-2 mb-2" style={{ marginLeft: '-50px' }}>
    //       <h5>Solutions</h5>
    //       <ul className="list-unstyled">
    //         <li><Link to="/services/sub-services?service=ev-charging">EV Charging Solutions</Link></li>
    //         <li><Link to="/services">Digital Transformation</Link></li>
    //         <li><Link to="/services/sub-services?service=digital-marketing">Marketing Solutions</Link></li>
    //         <li><Link to="/services/software-mobile">Customized Software</Link></li>
    //       </ul>
    //     </div>

    //     <div className="col-md-2 mb-2" style={{ marginLeft: '-40px' }}>
    //       <h5>Support</h5>
    //       <ul className="list-unstyled">
    //         <li>Consulting Services</li>
    //       </ul>
    //     </div>

    //     <div className="col-md-2 mb-4"  style={{ marginLeft: '-40px' }}>
    //       <h5>Contact Us</h5>
    //       <ul className="list-unstyled">
    //         <li>+94 (0) 770 065 647</li>
    //         <li>+94 (0) 112 677 171</li>
    //         <li><a href="mailto:info@ambrumsolutions.com">info@ambrumsolutions.com</a></li>
    //       </ul>
    //     </div>

    //     <div className="col-md-2 mb-4" style={{ marginLeft: '-40px' }}>
    //       <h5>Get in Touch</h5>
    //       <form>
    //         <input type="email" className="form-control mb-2" placeholder="Your email" />
    //       </form>
    //     </div>
    //   </div>
    // </div>


    <div className='footer p-md-5 p-3'>
  <div className='row'>
    <div className="col-lg-2 col-md-4 col-sm-6 mb-4 footer-left">
      <img src="../assets/images/logoLong.png" alt="Logo" className="footer-logo img-fluid" />
      <p className="footer-copy">&copy; All Right Reserved</p>

      <p className="footer-links">
        <Link to="/privacy-policy">Privacy Policy</Link>
        <Link to="/terms-and-conditions">Terms & Conditions</Link>
      </p>

      <div className="social-icons">
        <a href="https://www.linkedin.com/company/ambrumsolutions/" target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin"></i></a>
        <a href="https://www.facebook.com/ambrumSL" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook"></i></a>
        <a href="https://www.instagram.com/ambrum.s/" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
      </div>

      <div className="footer-divider d-none d-md-block" />
    </div>

    <div className="col-lg-2 col-md-4 col-sm-6 mb-4 footer-company">
      <h5>Company</h5>
      <ul className="list-unstyled">
        <li><Link to="/about">About</Link></li>
        <li><Link to="/services">Services</Link></li>
        <li><Link to="/careers">Careers</Link></li>
      </ul>
    </div>

    <div className="col-lg-2 col-md-4 col-sm-6 mb-4 footer-solutions">
      <h5>Solutions</h5>
      <ul className="list-unstyled">
        <li><Link to="/services/sub-services?service=ev-charging">EV Charging Solutions</Link></li>
        <li><Link to="/services">Digital Transformation</Link></li>
        <li><Link to="/services/sub-services?service=digital-marketing">Marketing Solutions</Link></li>
        <li><Link to="/services/software-mobile">Customized Software</Link></li>
      </ul>
    </div>

    <div className="col-lg-2 col-md-4 col-sm-6 mb-4 footer-support">
      <h5>Support</h5>
      <ul className="list-unstyled">
        <li>Consulting Services</li>
      </ul>
    </div>

    <div className="col-lg-2 col-md-4 col-sm-6 mb-4 footer-contact">
      <h5>Contact Us</h5>
      <ul className="list-unstyled">
        <li>+94 (0) 770 065 647</li>
        <li>+94 (0) 112 677 171</li>
        <li><a href="mailto:info@ambrumsolutions.com">info@ambrumsolutions.com</a></li>
      </ul>
    </div>

    <div className="col-lg-2 col-md-4 col-sm-6 mb-4 footer-newsletter">
      <h5>Get in Touch</h5>
      <form>
        <input type="email" className="form-control mb-2" placeholder="Your email" />
      </form>
    </div>
  </div>
</div>
  );
}
